@if (!purchase() && !transactionId && !redirectAfterPaymentAuthorize()) {
  <div class="py-6">
    @if (isLoadingPayment()) {
      <aw-loading-animation
        [entityType]="EEntityType.ticketConfiguration"
        [relationType]="
          ERelationType.loadingDirectTicketValidation
        "></aw-loading-animation>
    } @else {
      User: {{ userStore.userOrGuestId() }} <br />
      Preferred Payment: {{ preferredPaymentMethod() | json }}
      @if (preferredPaymentMethod()) {
        <aw-payment-method-display
          [paymentMethod]="preferredPaymentMethod()"
          id="preferred-payment"></aw-payment-method-display>
        <aw-button
          (click)="placeOrder(preferredPaymentMethod()!)"
          id="proceed-to-payment"
          type="button"
          >{{
            textStore.texts()
              | filterTexts
                : ERelationType.shoppingCartButtonCompleteLabel
                : EEntityType.shoppingCart
              | language
          }}</aw-button
        >
      } @else {
        @if (userStore.user()) {
          <aw-button
            [id]="'add-direct-payment'"
            [type]="'button'"
            [style]="'primary-alt'"
            (click)="addPaymentDirect()">
            <span
              [attr.data-testid]="'addPayment'"
              class="material-symbols-rounded">
              add
            </span>
            {{
              textStore.texts()
                | filterTexts
                  : ERelationType.choosePayment
                  : EEntityType.shoppingCart
                | language
            }}
          </aw-button>
        } @else {
          <aw-button
            (click)="placeGuestOrder(userStore.userOrGuestId())"
            id="pay-as-guest"
            type="button"
            >{{
              textStore.texts()
                | filterTexts
                  : ERelationType.shoppingCartButtonCompleteLabel
                  : EEntityType.shoppingCart
                | language
            }}</aw-button
          >
        }
      }
    }
  </div>
} @else {
  <div class="text-center text-2xl font-semibold">Kauf abgeschlossen!</div>
  <div class="pt-4 pb-8 text-center">
    Später wird hier entweder auf Erfolgsseite weitergeleitet, oder es wird ein
    Fehler ausgegeben.<br />
    Ggf. sollte es möglich sein nach einem Fehlerfall einen erneuten Kaufversuch
    zu starten.<br />
    Bitte nicht in der Ticketkonfiguration zurückgehen wenn ein Kaufversuch
    durchgeführt wurde, das ist eig. nicht vorgesehen und nur temporär möglich.
  </div>
}
@if (isTransactionInProgress()) {
  <div
    class="pointer-events-none fixed top-0 left-0 flex h-full w-full items-center justify-center bg-black/50">
    <div class="bg-white px-12 py-8">
      <aw-loading-animation></aw-loading-animation>
    </div>
  </div>
}
